import { createContext, useState, useCallback } from "react";
import { Outlet } from "react-router-dom";
import { toast } from "react-toastify";
import { apiV1 } from "./../lib/axios";

export const ReceiptsContext = createContext({});

export function ReceiptsProvider({children}) {

  const scanReceipt = useCallback(async (data) => {
    try {
      const response = await apiV1.post("receipt/scan", data);
      return response.data;
    } catch (error) {
      console.error("Erro ao escanear nota:", error);
    }
  }, []);

  const listReceipts = useCallback(async () => {
    try {
      const response = await apiV1.get("receipt/list");
      return response.data.data;
    } catch (error) {
      console.error("Erro ao listar notas:", error);
    }
  }, []);

  const createReceipt = useCallback(async (data) => {
    try {
      const response = await apiV1.post(`receipt/create`, data);
      return response.data;
    } catch (error) {
      console.error("Erro ao criar nota:", error);
    }
  }, []);

  const uploadReceipt = useCallback(async (data) => {
    try {
      const response = await apiV1.post("receipt/upload", data);
      return response.data;
    } catch (error) {
      console.error("Erro ao enviar nota:", error);
    }
  }, []);

  const listPartners = useCallback(async () => {
    try {
      const response = await apiV1.get("receipt/partner");
      return response.data.data;
    } catch (error) {
      console.error("Erro ao listar parceiros:", error);
    }
  }, []); 

  const contextValue = {
    scanReceipt,
    listReceipts,
    createReceipt,
    uploadReceipt,
    listPartners
  };

  return (
    <ReceiptsContext.Provider value={contextValue}>
     {children}
    </ReceiptsContext.Provider>
  );
}